import CreateAccountForm from "../create-account-form";
import PageLayout from "../../page-layout";
import { createGetRequest } from "utils/hooks/apiActions";
import { ApiURL, AppURL } from "utils/Actions";
import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Skeleton } from "antd";
import useQuery from "utils/hooks/useQuery";
import { Trans, useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { TokenResultCode } from "utils/Types";
import { useHistory, useLocation } from "react-router-dom";
import { handleRedirect } from "utils/hooks/handleRedirect";

export default function CreateAccount() {
  const { t } = useTranslation();
  const query = useQuery();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname + location?.search;
  const [errorType, setErrorType] = useState<TokenResultCode | undefined>(undefined);
  const [email, setEmail] = useState("");
  const [isTokenApiLoading, setIsTokenApiLoading] = useState(false);
  useEffect(() => {
    handleRedirect(history, path);
    checkValidToken();
  }, []);

  const checkValidToken = async () => {
    setIsTokenApiLoading(true);
    const token = query.get("token");
    try {
      const tokenResult = await createGetRequest({
        path: `${ApiURL.validToken}?t=${token}&a=set`
      });
      const tokenResultCode = tokenResult.data.data.data.resultCode;
      if (tokenResultCode === TokenResultCode.VALID) {
        setEmail(tokenResult.data.data.data.user);
      } else {
        setErrorType(tokenResultCode);
        throw new Error(tokenResultCode);
      }
    } catch (error: any) {
      console.error(error);
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data.message);
      }
    } finally {
      setIsTokenApiLoading(false);
    }
  };

  if (errorType !== undefined) {
    return (
      <PageLayout isSingleCard={true}>
        <div style={{ textAlign: "center" }}>
          <h1 style={{ marginBottom: 32 }}>{t(`createAccount.errors.${errorType}.heading`)}</h1>
          <p style={{ textAlign: "center", marginBottom: 32 }}>
            <Trans>{t(`createAccount.errors.${errorType}.message`)}</Trans>
          </p>
          {errorType === TokenResultCode.ALREADY_EXISTS && (
            <Button
              block
              type="primary"
              onClick={() => {
                history.push("/");
              }}
            >
              {t(`createAccount.errors.${errorType}.login`)}
            </Button>
          )}
          {errorType === TokenResultCode.EXPIRED && (
            <>
              <Button
                block
                type="primary"
                style={{ marginBottom: 16 }}
                onClick={() => {
                  history.push(AppURL.forgetPassword);
                }}
              >
                Set password
              </Button>
              <Button
                block
                type="link"
                onClick={() => {
                  history.push(AppURL.login);
                }}
              >
                Log in
              </Button>
            </>
          )}
          {errorType === TokenResultCode.INVALID && (
            <>
              <Button
                block
                type="primary"
                style={{ marginBottom: 16 }}
                onClick={() => {
                  history.push(AppURL.login);
                }}
              >
                Log in
              </Button>
              <Button
                block
                type="link"
                onClick={() => {
                  history.push(AppURL.forgetPassword);
                }}
              >
                Set password
              </Button>
            </>
          )}
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout isSingleCard={true}>
      <Helmet>
        <title>{t("helmet.createAccount.title")}</title>
        <meta name="description" content={t("helmet.createAccount.meta") || ""} />
      </Helmet>
      <h1 className="text-center">{t("createAccount.heading")}</h1>
      {isTokenApiLoading ? <Skeleton /> : <CreateAccountForm email={email} />}
    </PageLayout>
  );
}
